import React from 'react';

const SvgTenant: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-4 -4 24 24"
    {...props}
  >
    <path
      fill="#5A636B"
      d="M1 15V5.2a1 1 0 0 1 1-1h2.2V2a1 1 0 0 1 1-1h5.6a1 1 0 0 1 1 1v5.4H14a1 1 0 0 1 1 1V15H9v-3.2H7V15H1Zm1.2-1.2h2v-2h-2v2Zm0-3.2h2v-2h-2v2Zm0-3.2h2v-2h-2v2Zm3.2 3.2h2v-2h-2v2Zm0-3.2h2v-2h-2v2Zm0-3.2h2v-2h-2v2Zm3.2 6.4h2v-2h-2v2Zm0-3.2h2v-2h-2v2Zm0-3.2h2v-2h-2v2Zm3.2 9.6h2v-2h-2v2Zm0-3.2h2v-2h-2v2Z" // eslint-disable-line max-len
    />
  </svg>
);

export default SvgTenant;
